import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Paper, Grid, Stack, Typography, Button } from '@mui/material';
import { Add, Groups } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import '../../App.css';
import Popup from '../Popup';
import Notification from '../Notification';
import EmployeeStipendForm from './EmployeeStipendForm';
import EmployeeStipendTable from '../table-data/EmployeeStipendTable';

function ViewEmployeeStipend({ fetch_id }) {
  const [openFormPopup, setOpenFormPopup] = useState(false);
  const [selectedStipend, setSelectedStipend] = useState(null);
  const [stipendData, setStipendData] = useState(null);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const navigate = useNavigate();

  const fetchStipendHistory = async () => {
    if (!fetch_id) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/apprentice-master/get-stipend/${fetch_id}`
      );
      setStipendData(response.data || null);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error',
        });
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        setNotify({
          isOpen: true,
          message: 'Failed to fetch stipend history',
          type: 'error',
        });
      }
    }
  };

  useEffect(() => {
    fetchStipendHistory();
  }, [fetch_id]);

  const handleAddClick = () => {
    setSelectedStipend(null);
    setOpenFormPopup(true);
  };

  const handleEditStipend = (stipend) => {
    setSelectedStipend(stipend);
    setOpenFormPopup(true);
  };

  const handleFormSuccess = () => {
    setOpenFormPopup(false);
    fetchStipendHistory();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        margin: '10px',
        padding: '30px',
        marginTop: '-40px',
        fontWeight: '500px',
      }}
    >
      <Paper elevation={0}>
        <Grid className="form-title" style={{ marginBottom: '-60px' }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: 'center', margin: 5 }}>
               Stipend
            </Typography>
          </Grid>
          <Grid item>
            <Groups style={{ marginLeft: '-30px' }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ margin: '30px' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ width: '100%' }}
          >
            <Button
              style={{ width: '160px' }}
              className="form-btn"
              variant="outlined"
              color="success"
              onClick={handleAddClick}
              startIcon={<Add sx={{ width: '24px', height: '24px' }} />}
              sx={{
                whiteSpace: 'nowrap',
                textTransform: 'none',
              }}
            >
              Add Stipend
            </Button>
          </Stack>

          <EmployeeStipendTable stipendData={stipendData} onEditStipend={handleEditStipend} />
        </Stack>

        <Popup
          title={selectedStipend ? 'Edit Stipend' : 'Add Stipend'}
          openPopup={openFormPopup}
          setOpenPopup={setOpenFormPopup}
        >
          <EmployeeStipendForm
            employeeId={fetch_id}
            initialData={selectedStipend}
            onSuccess={handleFormSuccess}
          />
        </Popup>

        <Notification notify={notify} setNotify={setNotify} />
      </Paper>
    </Box>
  );
}

export default ViewEmployeeStipend;

